module.exports = __webpack_public_path__ + "static/media/RedSMS.bcae686b.svg";